module.exports = "data:image/gif;base64,R0lGODlhFwAQAMQAAAAAAP///wDKDQB6CQClCBmpHxmlICWrLDu+Qj+xRn25gAHJBia+KyWMKDq1PkzKUE61Ub7avxmlGibKKEy+TFmxWVCeUF+yX77avnPKcnKxcVayU7DPr////wAAAAAAACH5BAEAAB0ALAAAAAAXABAAAAVLYCeOZGmeaKqu5LWxaJU9Bmwmz0R0w9izEISgwPv9VhHGAlMUGY3OqOMQ7VmrUV5HockOrN+rWMTxXknHH0WS1RahWUvDRq/b76kQADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/newDocument_EN.gif
// module id = inF2
// module chunks = 1